import {TaskType} from "./types";

export const getTaskElementTemplate = ({name, id, url, priority, projectName}: TaskType, userId: number) => {
  return `<li class="task__item task__item--queue js-task-item-${userId} js-show-all-item" data-id="${id}" data-user-type="admin">
    <a class="task__name" href="${url}">
      ${name}
    </a>
    <div class="task__info task__info--queue">
      <p class="task__project task__project--queue">${projectName}</p>
      <div class="task__priority priority  priority--queue js-priority-select-${userId}">
        <label class="priority__block js-priority-color priority__block--priority-${priority}" tabindex="0">
          <input class="js-select-h-input js-priority-h-input" type="hidden" value="${priority}">
          <span class="visually-hidden">Приоритет</span>
          <span class="priority__text js-select-input js-favorite-prioriry">${priority}</span>
        </label>
        <div class="priority__modal priority__modal--small js-select-list">
          <div class="priority__list">
            <button type="button" class="priority__block priority__block--priority-10 js-select-item" data-value="10" aria-label="Приоритет 10">
                10
            </button>
            <button type="button" class="priority__block priority__block--priority-9 js-select-item" data-value="9" aria-label="Приоритет 9">
                9
            </button>
            <button type="button" class="priority__block priority__block--priority-8 js-select-item" data-value="8" aria-label="Приоритет 8">
                8
            </button>
            <button type="button" class="priority__block priority__block--priority-7 js-select-item" data-value="7" aria-label="Приоритет 7">
                7
            </button>
            <button type="button" class="priority__block priority__block--priority-6 js-select-item" data-value="6" aria-label="Приоритет 6">
                6
            </button>
            <button type="button" class="priority__block priority__block--priority-5 js-select-item" data-value="5" aria-label="Приоритет 5">
                5
            </button>
            <button type="button" class="priority__block priority__block--priority-4 js-select-item" data-value="4" aria-label="Приоритет 4">
                4
            </button>
            <button type="button" class="priority__block priority__block--priority-3 js-select-item" data-value="3" aria-label="Приоритет 3">
                3
            </button>
            <button type="button" class="priority__block priority__block--priority-2 js-select-item" data-value="2" aria-label="Приоритет 2">
                2
            </button>
            <button type="button" class="priority__block priority__block--priority-1 js-select-item" data-value="1" aria-label="Приоритет 1">
                1
            </button>
        </div>
        </div>
      </div>
    </div>
  </li>`;
};
